const isPoint = point => point.hasOwnProperty('x') && point.hasOwnProperty('y');
export { isPoint };